//
// ModuleUnregisterMenu
//
// Unregister a module in the ProjectModulesInspector

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { VView } from '../appview'
import { Header, Menu, MenuDivider, MenuItem, Text } from '../components'

const ConfirmUnregisterSubmenu = observer(function ConfirmUnregisterSubmenu({
    onAction,
}) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <VView className="actions-panel" style={{ width: 220 }}>
            <div className="inspector">
                <Header>{app.text('Unregister this module')}</Header>
                <Text className="cc-danger">
                    {app.text(
                        'This module and all its keys, actions, and logs will be removed.'
                    )}
                </Text>
            </div>
            <Menu style={{ maxWidth: 220 }}>
                <MenuItem
                    className="cc-danger"
                    onClick={() => _onAction('unregister_module')}
                >
                    {app.text('Yes, unregister this module')}
                </MenuItem>
                <MenuDivider />
                <MenuItem onClick={e => _onAction('cancel')}>
                    {app.text('Cancel')}
                </MenuItem>
            </Menu>
        </VView>
    )
})

export const ModuleUnregisterMenu = observer(function ModuleUnregisterMenu({
    onAction,
}) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <Menu>
            <MenuItem
                className="cc-danger"
                submenu={<ConfirmUnregisterSubmenu onAction={_onAction} />}
            >
                {app.text('Unregister module')}
            </MenuItem>
        </Menu>
    )
})
